import dayjs from "dayjs";

/**
 * Checks whether the current user is allowed to edit a student.
 * Rule:
 * - Super Admins can always edit.
 * - Center Admins (and any non-superadmin) cannot edit if more than 7 days (1 week)
 *   have elapsed since the student's creation date (created_at).
 *   (Fallback to registration_date / DOJ if created_at is not available).
 *
 * @param userRole - Role of the current logged-in user ('superadmin', 'centeradmin', etc.)
 * @param createdAt - Student's creation timestamp (created_at)
 * @param registrationDate - Fallback: Student's Date of Joining (registration_date / DOJ)
 * @returns boolean - True if editing is permitted, false otherwise
 */
export const canEditStudent = (
  userRole: string | undefined | null,
  createdAt?: string | null,
  registrationDate?: string | null
): boolean => {
  if (userRole === "superadmin") {
    return true;
  }

  const creationDateRaw = createdAt || registrationDate;
  if (!creationDateRaw) {
    return true;
  }

  const creationDate = dayjs(creationDateRaw);
  if (!creationDate.isValid()) {
    return true;
  }

  // 1 week limit = 7 days from creation date
  const editCutoffDate = creationDate.add(7, "day").endOf("day");
  const now = dayjs();

  return !now.isAfter(editCutoffDate);
};
